import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IFormulario } from 'src/app/models/Formulario';
import { Input, Output, EventEmitter } from '@angular/core';
import { NotificationService } from 'src/app/service/notificaciones.service';

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css']
})
export class FormularioComponent implements OnChanges{

  @Input() formulario: IFormulario[] = [];
  @Input() url_imagen_cabecera: string[] = [];
  @Input() url_imagenes_bottom: string[] = [];
  @Input() bloquear_envio: boolean = false;
  @Input() data: any = {};

  @Output() onChange = new EventEmitter<any>();
  @Output() enviarFormulario = new EventEmitter<any>();

  registroForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private notificacionesService: NotificationService) {
    this.registroForm = this.formBuilder.group({});
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(this.data)
    if (changes['formulario'] && changes['formulario'].currentValue !== null) {
      this.generarFormulario();
      this.crearGetters();
    }
    this.registroForm.valueChanges.subscribe((value) => {
      this.onChangeDatos(value);
    });
    if (this.data) {
      const { enviar, ...datos_usuario_editar } = this.data;
      this.registroForm.patchValue(datos_usuario_editar);
      console.log('datos', this.registroForm, this.formulario)
    }
  }

  generarFormulario(): void {
    const formGroupConfig: any = {};
    this.formulario.forEach(elemento => {
      if (elemento.fields.length > 1) {
        const validators = elemento.validador ? this.obtenerValidadores(elemento) : [];
        let valorInicializado;
        elemento.parametros.forEach(parametros => {
          switch (parametros.tipo) {
            case 'string':
              valorInicializado = '';
              break;
            case 'number':
              valorInicializado = 0;
              break;
            case 'boolean':
              valorInicializado = false;
              break;
            case 'date':
              valorInicializado = null;
              break;
            default:
              valorInicializado = null;
              break;
          }
        });
        formGroupConfig[elemento.fields[0]] = [valorInicializado, validators[0]];
        formGroupConfig[elemento.fields[1]] = [valorInicializado, validators[1]];
  
      } else {
        let valorInicializado;
        const validators = elemento.validador ? this.obtenerValidadores(elemento) : [];
        if(validators[0].length > 1 || elemento.validador[0] == true){
          switch (elemento.parametros[0].tipo) {
            case 'string':
              valorInicializado = '';
              break;
              case 'number':
                valorInicializado = 0;
                break;
                case 'boolean':
                  valorInicializado = false;
                  break;
            case 'date':
              valorInicializado = null;
              break;
            default:
              valorInicializado = null;
              break;
            }
            formGroupConfig[elemento.fields[0]] = [valorInicializado, validators[0]];
          } else{
            formGroupConfig[elemento.fields[0]] = [valorInicializado];
        }
      }
    });
    this.registroForm = this.formBuilder.group(formGroupConfig);
  }

  obtenerValidadores(elemento: IFormulario): any[] {
    const validadores: any[] = [];
    const correoPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const telefonoPattern = /^[0-9]{9}$/;
    const dniPattern = /^[0-9]{8}[A-Za-z]$/;
    const codigoPostalPattern = /^[0-9]{5}$/;
  
    const tipoArray = Array.isArray(elemento.type) ? elemento.type : [elemento.type];
    const validadorArray = Array.isArray(elemento.validador) ? elemento.validador : [elemento.validador];
  
    tipoArray.forEach((tipo, index) => {
      const validadoresPorCampo: any[] = []; 
      if (validadorArray[index] === true) {
        switch (tipo) {
          case 'text':
            validadoresPorCampo.push(Validators.required, Validators.minLength(3));
            break;
          case 'telefono':
            validadoresPorCampo.push(Validators.required, Validators.pattern(telefonoPattern), Validators.minLength(9), Validators.maxLength(9));
            break;
          case 'correo':
            validadoresPorCampo.push(Validators.required,Validators.minLength(3), Validators.pattern(correoPattern));
            break;
          case 'aceptar-check':
            validadoresPorCampo.push(Validators.required);
            break;
          case 'dropdown':
            validadoresPorCampo.push(Validators.required);
            break;
          case 'dni':
            validadoresPorCampo.push(Validators.required, Validators.pattern(dniPattern));
            break;
          case 'codigo_postal':
            validadoresPorCampo.push(Validators.required, Validators.pattern(codigoPostalPattern), Validators.maxLength(5));
            break;
          default:
            validadoresPorCampo.push(Validators.required);
            break;
        }
      } else {
        validadoresPorCampo.push([]); 
      }
      validadores.push(validadoresPorCampo); 
    });
    return validadores;
  }
  
  
  crearGetters(): void {
    this.formulario.forEach(elemento => {
      if (Array.isArray(elemento.fields)) {
        elemento.fields.forEach(field => {
          if (!Object.getOwnPropertyDescriptor(this, field)) {
            Object.defineProperty(this, field, {
              get: function() {
                return this.registroForm.get(field);
              },
              configurable: true
            });
          }
        });
      } else {
        if (!Object.getOwnPropertyDescriptor(this, elemento.fields)) {
          Object.defineProperty(this, elemento.fields, {
            get: function() {
              return this.registroForm.get(elemento.fields);
            },
            configurable: true
          });
        }
      }
    });
  }
  
  onChangeDatos(value: any) {
    this.onChange.emit(value);
  }

  enviarParametros(): void {
    this.formulario.forEach(elemento => {
      if (Array.isArray(elemento.fields)) {
        elemento.fields.forEach(field => {
          const control = this.registroForm.controls[field];
          if (control && control.status !== 'VALID') {
            let errorMessage = '';
            if (control.errors?.['required']) {
              errorMessage = `Falta por introducir el campo ${elemento.headers[elemento.fields.indexOf(field)]}`;
            } else if (control.errors?.['minlength']) {
              errorMessage = `El campo ${elemento.headers[elemento.fields.indexOf(field)].toLowerCase()} debe tener al menos ${control.errors['minlength'].requiredLength} caracteres.`;
            } else if (control.errors?.['maxlength']) {
              errorMessage = `El campo ${elemento.headers[elemento.fields.indexOf(field)].toLowerCase()} debe tener como máximo ${control.errors['maxlength'].requiredLength} caracteres.`;
            } else if (control.errors?.['pattern']) {
              errorMessage = `El campo ${elemento.headers[elemento.fields.indexOf(field)].toLowerCase()} no tiene el formato correcto.`;
            }
            const header = Array.isArray(elemento.headers) ? elemento.headers[elemento.fields.indexOf(field)] : elemento.headers;
            this.notificacionesService.notificacionError(errorMessage || `Error en el campo ${header}`);
          }
        });
      } else {
        const control = this.registroForm.controls[elemento.fields];
        if (control && control.status !== 'VALID') {
          let errorMessage = '';
          if (control.errors?.['required']) {
            errorMessage = `Falta por introducir el campo ${elemento.headers}`;
          } else if (control.errors?.['minlength']) {
            errorMessage = `El campo ${elemento.headers} debe tener al menos ${control.errors['minlength'].requiredLength} caracteres.`;
          } else if (control.errors?.['maxlength']) {
            errorMessage = `El campo ${elemento.headers} debe tener como máximo ${control.errors['maxlength'].requiredLength} caracteres.`;
          } else if (control.errors?.['pattern']) {
            errorMessage = `El campo ${elemento.headers} no tiene el formato correcto.`;
          }
          this.notificacionesService.notificacionError(errorMessage || `Error en el campo ${elemento.headers}`);
        }
      }
    });
    if (this.registroForm.valid) {
      const formularioValue = this.registroForm.value;
      this.enviarFormulario.emit(formularioValue);
      if(this.bloquear_envio){
        this.registroForm.disable();
      }
    } else {
      this.marcarCamposInvalidos(this.registroForm);
    }
  }
  
  marcarCamposInvalidos(formGroup: FormGroup): void {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control !== null && control !== undefined) {
        if (control instanceof FormGroup) {
          this.marcarCamposInvalidos(control);
        } else {
          control.markAsTouched({ onlySelf: true });
        }
      }
    });
  }

  onValorSeleccionado(valor: string[], field: string) {
    this.registroForm.get(field)?.setValue(valor);
  }
}
